import { render, staticRenderFns } from "./RecebimentoDetalhes.vue?vue&type=template&id=740838d4"
import script from "./RecebimentoDetalhes.vue?vue&type=script&lang=js"
export * from "./RecebimentoDetalhes.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoDetalhes.vue?vue&type=style&index=0&id=740838d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports